<template>
    <div id="multiselectDialog" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false"
        aria-labelledby="multiselectDialogTitle" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content wizard-content">
                <div class="modal-header wizard-header">
                    <h5 class="modal-title wizard-title" id="multiselectDialogTitle">
                        SELECT TEETH
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body wizard-body">
                    <div class="step-main">
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-light dentition-selected">
                                MAXILLA
                            </button>
                        </div>
                        <div id="multiselect1" class="multiselect-step">
                            <div class="stl-group">
                                <div id="multiselect1Viewer" class="multiselect-viewer">
                                </div>
                                <img class="multiselect-spinner centered-spinner" src="images/dark-blue-spinner.gif" />
                            </div>
                        </div>
                        <div class="btn-group btn-group2" role="group">
                            <button type="button" class="btn btn-light dentition-selected">
                                MANDIBULAR
                            </button>
                        </div>
                        <div id="multiselect2" class="multiselect-step">
                            <div class="stl-group">
                                <div id="multiselect2Viewer" class="multiselect-viewer">
                                </div>
                                <img class="multiselect-spinner centered-spinner" src="images/dark-blue-spinner.gif" />
                            </div>
                        </div>

                        <!-- <div class="btn-group btn-group3" role="group">
                            <button type="button" v-on:click="switchShowClick(true)" class="btn btn-light">
                                SHOW
                            </button>
                            <button type="button" v-on:click="switchShowClick(false)" class="btn btn-light">
                                HIDE
                            </button>
                        </div> -->

                    </div>
                </div>

                <div class="modal-footer wizard-footer">
                    <button id="btnShowOnly" type="button" class="btn btn-primary btn-next"
                        v-on:click="showOnlyClick()">
                        SHOW ONLY
                    </button>
                    <button id="btnHide" type="button" class="btn btn-primary btn-next" v-on:click="hideClick()">
                        HIDE
                    </button>
                    <button id="btnReset" type="button" class="btn btn-primary btn-next" v-on:click="resetClick()">
                        RESET
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {
    multiselectShowOnly,
    multiselectHide,
    multiselectResetVisibility
} from "./MultiselectManager";

export default {
    name: "multiselectDialog",
    props: [],
    data() {
        return {
            isShow: true,
        };
    },
    methods: {
        // switchShowClick: function (value) {
        //     this.isShow = value;
        //     switchShow(value);
        // },
        showOnlyClick: function () {
            multiselectShowOnly();
        },
        hideClick: function () {
            multiselectHide();
        },
        resetClick: function () {
            multiselectResetVisibility();
        }
    },
    mounted() {
        // initMultiselectViewers();
    },
};
</script>

<style scoped>
@import "../../css/wizard.css";

.modal-dialog {
    max-width: 600px;
    max-height: 100%;
}

.modal-content {
    max-height: 100vh;
}

.modal-title {
    margin-top: 2px;
    max-width: 300px;
    width: 300px;
    left: calc(50% - 145px);
    font-size: 1rem;
}

.modal-body {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 5px;
}

.modal-header {
    padding: 0.4rem 0.5rem 0.3rem 0.5rem;
}

.modal-header .close {
    padding: 0.4rem;
    margin: -0.4rem -0.4rem -0.6rem auto;
}

.step-main {
    /* margin-top: 15px; */
    text-align: center;
}

.btn {
    border-radius: 0px;
    /* border: 1px solid #000000; */
    width: 170px;
    font-size: 0.8rem;
    padding: .2rem .5rem;
}

.btn-next {
    height: auto;
    width: 140px;
}

.btn-group2 {
    margin-top: 15px;
}

.btn-group3 {
    margin-top: 15px;
}

.step-description {
    text-align: center;
    color: #0069d9;
    margin-top: 5px;
    font-size: 0.8rem;
}

.dentition-selected {
    background-color: #77a7fd;
    /* #deeaf6; */
}

.stl-group {
    margin-top: 10px;
    height: 300px;
    max-height: 25vh;
    width: 100%;
    position: relative;
    cursor: pointer;
}

/* @media (max-height: 600px) {
    .stl-group {
        height: 250px;
    }
} */

.multiselect-viewer {
    background-color: #EEF3FF;
    position: absolute;
    width: 100%;
    height: 100%;
}

.multiselect-spinner {
    position: absolute;
    display: none;
    width: 100px;
    height: 100px;
    left: calc(50% - 50px);
    top: 405px;
    text-align: center;
    z-index: 9;
}
</style>
